export default {
  async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  },
  isEmpty(obj) {
    return Object.keys(obj).length === 0
  },

  truncate(str, n) {
    return str.length > n ? str.substr(0, n - 1) + '&hellip;' : str
  },

  checkIfDuplicateExists(w) {
    return new Set(w).size !== w.length
  },

  createUniqueIds(w: Array<number>): Set<number> {
    return new Set(w)
  },

  roughSizeOfObject(object) {
    return JSON.stringify(object).length
  },
}
